var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.63 45.11"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:6.67;stroke-width:4.05px;}.cls-1,.cls-2{fill:none;stroke:var(--konflux-icon-color, #1A1A1A);stroke-linecap:round;}.cls-2{stroke-linejoin:round;stroke-width:3.81px;}.cls-3{fill:var(--konflux-primary-color, #FF9D76);stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8.73,
    y: 8.11,
    width: 45,
    height: 37,
    rx: 3.37,
    ry: 3.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.97,8.78v-1.35c0-2.99-2.42-5.4-5.4-5.4H7.43c-2.99,0-5.4,2.42-5.4,5.4v27.02c0,2.99,2.42,5.4,5.4,5.4h35.13c2.99,0,5.4-2.42,5.4-5.4v-1.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.77,20.94h27.95M61.73,20.94l-7.62-7.62M61.73,20.94l-7.62,7.62"
  }))));
};
export default SvgSend;